module.exports = __webpack_public_path__ + "static/tonezone-9533ec1f677c1ea62855c44af8758dec.png";